// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"89d957cb","143":"d4fe2632","393":"c26ad629","424":"8cbce695","533":"d4814aaf","651":"ccebccb0","690":"63fb1d31","852":"6d013e0c","940":"5aba3533"}[chunkId] + ".chunk.js";
};